import axios from 'axios';
import { getLocalizeUrl } from '../../shared/utils/url';

export const getTroubleshootingConfigRequest = (troubleshootingGuide, locale, params) => {
  const troubleshootingUrl = getLocalizeUrl(
    `/contactus/api/troubleshooting/${troubleshootingGuide}?version=4`,
    locale
  );
  return axios.get(troubleshootingUrl, { params });
};

export const uploadFilesApi = formData => {
  return axios.post('/contactus/api/energy-support-files', formData);
};
